import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { VehiclesService } from 'src/app/_services/vehicles.service';
import { ServiceReminderService } from 'src/app/_services/service-reminder.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-update-service-reminder',
  templateUrl: './update-service-reminder.component.html',
  styleUrls: ['./update-service-reminder.component.scss'],
})
export class UpdateServiceReminderComponent implements OnInit {
  data: any;
  vehicleList: any[] = [];
  loading: boolean = false;
  serviceForm = this.fb.group({
    service_delta: [''],
    service_due_date: [''],
    vehicle_reference: [''],
    vehicle_id: [''],
    km_reading: [''],
  });

  constructor(
    private fb: FormBuilder,
    private config: DynamicDialogConfig,
    private vehiclesService: VehiclesService,
    private serviceReminderService: ServiceReminderService,
    private ref: DynamicDialogRef,
    public messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.data = this.config.data;

    this.vehiclesService.getVehicles().subscribe((vehicles: any[]) => {
      this.vehicleList = vehicles
        .map((vehicle) => ({
          vehicle_reference: vehicle.vehicle_reference,
          service_interval: vehicle.service_interval,
        }))
        .sort((a: any, b: any) =>
          a.vehicle_reference.localeCompare(b.vehicle_reference),
        );
    });

    this.data = this.config.data;
    const dueDate = this.data.service_due_date
      ? new Date(this.data.service_due_date)
      : null;
    this.serviceForm.patchValue({
      service_delta: this.data.service_delta,
      service_due_date: dueDate as any,
      vehicle_reference: this.data.vehicle_reference,
      vehicle_id: this.data.vehicle_id,
      km_reading: this.data.km_reading,
    });
  }

  onChangeVehicleReference() {}

  updateReminder() {
    this.loading = true;
    const vehicle_reference: string =
      this.serviceForm.get('vehicle_reference')!.value!;
    this.vehiclesService
      .getVehicleByReference(vehicle_reference)
      .subscribe((vehicleData) => {
        const rawDate = this.serviceForm.get('service_due_date')!.value;
        const formattedDate = rawDate
          ? formatDate(rawDate, 'yyyy-MM-dd', 'en')
          : null;
        this.serviceForm.patchValue({
          vehicle_id: vehicleData.body.id,
          service_due_date: formattedDate,
        });
        this.serviceReminderService
          .updateReminder(this.serviceForm.value, this.data.id)
          .subscribe(
            (data) => {
              this.ref.close(data);
            },
            () => {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'An error occurred while updating the service reminder',
                key: 'service_reminder',
              });
              this.ref.close();
            },
            () => {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Service reminder updated successfully',
                key: 'service_reminder',
              });
              this.ref.close('updated');
            },
          );
      });
  }
}
